import { render, staticRenderFns } from "./panic-buy.vue?vue&type=template&id=fbb18084&scoped=true&"
import script from "./panic-buy.vue?vue&type=script&lang=ts&"
export * from "./panic-buy.vue?vue&type=script&lang=ts&"
import style0 from "./panic-buy.vue?vue&type=style&index=0&id=fbb18084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb18084",
  null
  
)

export default component.exports